import './Video.css';

import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

export default function Video({ videoUrl, title }) {
    return (
        <div className='video'>
            <LiteYouTubeEmbed id={videoUrl} title={title}></LiteYouTubeEmbed>
        </div>
    )
}